/* eslint-disable no-param-reassign */
import { Chart } from 'chart.js';

import { numberWithPrefix } from 'common/utils/functions';

const getOrCreateLegendList = (_: any, id: any) => {
  const legendContainer = document.getElementById(id);
  if (!legendContainer) return null;
  let listContainer = legendContainer.querySelector('ul');

  if (!listContainer) {
    listContainer = document.createElement('ul');
    listContainer.classList.add('o-chart_legendCustom_container');
    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};

const generateLabel = (chart: any, item: any, isMultipleType?: boolean) => {
  const li = document.createElement('li');
  li.classList.add('o-chart_legendCustom_item');

  li.onclick = () => {
    const chartConfig = chart.config;
    if (chartConfig.type === 'pie') {
      // Pie and doughnut charts only have a single dataset and visibility is per item
      chart.toggleDataVisibility(item.index);
    } else {
      chart.setDatasetVisibility(
        item.datasetIndex,
        !chart.isDatasetVisible(item.datasetIndex)
      );
      li.style.textDecoration = chart?.isDatasetVisible(item.datasetIndex) ? '' : 'line-through';
    }
    chart.update();
  };

  // Color box
  const boxSpan = document.createElement('span');
  boxSpan.className = isMultipleType ? 'o-chart_legendCustom_box o-chart_legendCustom_box-multiple' : 'o-chart_legendCustom_box';
  boxSpan.style.background = item.fillStyle;
  boxSpan.style.borderColor = item.strokeStyle;
  boxSpan.style.borderWidth = `${item.lineWidth}px`;

  // Text
  const textContainer = document.createElement('span');
  const wrapper = document.createElement('div');
  textContainer.style.textDecoration = item.hidden ? 'line-through' : '';

  const text = document.createTextNode(item.text);
  textContainer.appendChild(text);
  wrapper.appendChild(textContainer);

  if (chart?.data.datasets[0].data[item.index]) {
    const decsContainer = document.createElement('p');
    const desc = document.createTextNode(
      numberWithPrefix(chart.data.datasets[0].data[item.index], '.'),
    );
    decsContainer.appendChild(desc);
    wrapper.appendChild(decsContainer);
  }

  li.appendChild(boxSpan);
  li.appendChild(wrapper);
  return li;
};

export interface HtmlLegendOptions {
  containerID: string;
}

export const htmlLegendPlugin: any = () => ({
  id: 'htmlLegend',
  afterUpdate(chart: Chart<'doughnut'>, _args: any, options?: HtmlLegendOptions) {
    const containerID = (options as HtmlLegendOptions)?.containerID;
    const legendContainer = document.getElementById(containerID);
    if (!legendContainer) return;

    const { innerWidth } = window;
    legendContainer.innerHTML = '';

    const list = document.createElement('div');
    list.style.display = 'flex';
    list.style.flexDirection = 'column';

    // const data = chart.data.datasets[0]?.data || [];
    // const total = data.reduce((sum, val) => sum + Number(val), 0);

    chart.legend?.legendItems?.forEach((item) => {
      const listItem = document.createElement('div');
      listItem.style.display = 'flex';
      listItem.style.alignItems = 'center';
      listItem.style.cursor = 'pointer';
      listItem.style.marginBottom = '4px';

      const box = document.createElement('span');
      box.style.background = item.fillStyle as string;
      box.style.width = '40px';
      box.style.height = '12px';
      box.style.display = 'inline-block';
      box.style.marginRight = '8px';
      box.style.flexShrink = '0';

      const { index } = item as any;
      // const value = data[index];
      // const percentage = total ? ((Number(value) / total) * 100).toFixed(2) : '0';

      const text = document.createElement('span');
      // text.innerHTML = `${item.text}: ${value} (${percentage}%)`;
      text.innerHTML = item.text;

      if (innerWidth <= 1366) {
        text.style.fontSize = '10px';
      }

      listItem.appendChild(box);
      listItem.appendChild(text);

      listItem.onclick = () => {
        chart.toggleDataVisibility(index);
        chart.update();
      };

      list.appendChild(listItem);
    });

    legendContainer.appendChild(list);
  },
});

const htmlLegendPiePlugin = (
  legendCustomId: string,
  isMultipleType?: boolean,
  onlyTotal?: boolean
) => ({
  id: 'htmlLegend',
  afterUpdate(chart: any) {
    const ul = getOrCreateLegendList(chart, legendCustomId);

    if (!ul) return;
    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);
    ul.className = 'o-chart_legendCustom';
    if (onlyTotal && items.length > 0) {
      const li = generateLabel(chart, items[0], isMultipleType);
      ul.appendChild(li);
    } else {
      items?.forEach((item: any) => {
        const li = generateLabel(chart, item, isMultipleType);
        ul.appendChild(li);
      });
    }
  },
});

export default htmlLegendPiePlugin;
